/**
 * Enum for standardized toast durations.
 *
 * Provides predefined options for the duration of toast notifications:
 * - Short: 3000ms (3 seconds)
 * - Medium: 5000ms (5 seconds)
 * - Long: 7000ms (7 seconds)
 */
export enum ToastDuration {
  /**
   * Short duration for quick notifications (3 seconds).
   */
  Short = 3000,

  /**
   * Medium duration for standard notifications (5 seconds).
   */
  Medium = 5000,

  /**
   * Long duration for extended notifications (7 seconds).
   */
  Long = 7000,
}
